var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "card" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "flex justify-content-between" }, [
              _c(
                "div",
                { staticClass: "input-group" },
                [
                  _c("multiselect", {
                    staticClass: "multiselect",
                    attrs: {
                      name: "stores",
                      noShotCuts: true,
                      options: _vm.sortedStores,
                      placeholder: "Выберите склады",
                      "track-by": "title",
                      label: "title",
                      showLabels: false,
                      searchable: true,
                      multiple: true,
                    },
                    model: {
                      value: _vm.selectedStores,
                      callback: function ($$v) {
                        _vm.selectedStores = $$v
                      },
                      expression: "selectedStores",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-group-append" },
                    [
                      _c(
                        "vue-ladda",
                        {
                          attrs: {
                            "button-class": "btn btn-info",
                            "data-style": "zoom-in",
                            loading: _vm.btn_loading,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.showOverStore()
                            },
                          },
                        },
                        [_vm._v("Показать излишки\n                ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "alert alert-dark p-2 mt-1" },
              [
                _c("p", [_vm._v("Предараты для игнорирования")]),
                _vm._v(" "),
                _c("DrugSearchNew", {
                  ref: "searchDrug",
                  attrs: { onSelect: (d) => _vm.addIgnoredDrug(d) },
                }),
                _vm._v(" "),
                _vm._l(_vm.ignoredDrugs, function (drug, id) {
                  return _c(
                    "div",
                    { staticClass: "flex justify-content-between hover mt-1" },
                    [
                      _c("span", [_vm._v(_vm._s(drug.title))]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-default btn-xs",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.removeIgnoredDrug(id)
                            },
                          },
                        },
                        [_c("i", { staticClass: "icon-fa icon-fa-remove" })]
                      ),
                    ]
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            Object.keys(_vm.storeDetails).length &&
            Object.keys(_vm.storeDetails).length > 1 &&
            _vm.allowToSendAll
              ? _c(
                  "div",
                  { staticClass: "text-right mt-2" },
                  [
                    _c("LoadingButton", {
                      attrs: {
                        title: "Создать накладные для всех складов",
                        className: "btn btn-success",
                        onClick: () => _vm.createAllInvoice(),
                        loading: _vm.exportLoading,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-12" }, [
        _c(
          "div",
          { staticClass: "flex flex-wrap" },
          _vm._l(_vm.getSelectedStores(), function (store) {
            return (_vm.loadingDetails[store.id] ||
              _vm.storeDetails[store.id]) &&
              !_vm.sendInvoices[store.id]
              ? _c("div", { staticClass: "card item" }, [
                  _c("div", { staticClass: "card-header" }, [
                    _c("div", { staticClass: "flex justify-content-between" }, [
                      _c("div", [
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.$AllStores[store.id]?.title ?? store.id)
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      !_vm.loadingDetails[store.id]
                        ? _c(
                            "div",
                            { staticClass: "flex justify-content-end" },
                            [
                              _c("LoadingButton", {
                                attrs: {
                                  title: "XLS",
                                  className: "btn btn-outline-info mr-1",
                                  onClick: () => _vm.exportXLS(store.id),
                                  loading: _vm.exportLoading,
                                },
                              }),
                              _vm._v(" "),
                              !_vm.storeDetails[store.id].collectingInvoices ||
                              !_vm.storeDetails[store.id].collectingInvoices
                                .length
                                ? _c("LoadingButton", {
                                    attrs: {
                                      title: "Создать накладную перемещения",
                                      className: "btn btn-success",
                                      onClick: () =>
                                        _vm.createNewInvoice(store.id),
                                      loading: _vm.exportLoading,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card-body" },
                    [
                      _c("pulse-loader", {
                        staticClass: "text-center",
                        attrs: {
                          loading: _vm.loadingDetails[store.id],
                          color: _vm.$constants.LOADING_COLOR,
                        },
                      }),
                      _vm._v(" "),
                      _vm.storeDetails[store.id] &&
                      _vm.storeDetails[store.id].drugs
                        ? [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex justify-content-between mt-1 mb-2",
                              },
                              [
                                _vm.storeDetails[store.id].invoiceInUse.in &&
                                Object.keys(
                                  _vm.storeDetails[store.id].invoiceInUse.in
                                ).length
                                  ? _c("div", [
                                      _vm._v(
                                        "\n                  Учитывать накладные поступления на склад:\n                  "
                                      ),
                                      _c(
                                        "div",
                                        _vm._l(
                                          _vm.getInvoiceList(
                                            _vm.storeDetails[store.id]
                                              .invoiceInUse.in
                                          ),
                                          function (inv, ind) {
                                            return _c(
                                              "div",
                                              {
                                                key: ind.id,
                                                staticClass: "mb-1",
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.countIncomes[
                                                          store.id
                                                        ][inv.id],
                                                      expression:
                                                        "countIncomes[store.id][inv.id]",
                                                    },
                                                  ],
                                                  attrs: { type: "checkbox" },
                                                  domProps: {
                                                    checked: Array.isArray(
                                                      _vm.countIncomes[
                                                        store.id
                                                      ][inv.id]
                                                    )
                                                      ? _vm._i(
                                                          _vm.countIncomes[
                                                            store.id
                                                          ][inv.id],
                                                          null
                                                        ) > -1
                                                      : _vm.countIncomes[
                                                          store.id
                                                        ][inv.id],
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      var $$a =
                                                          _vm.countIncomes[
                                                            store.id
                                                          ][inv.id],
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = null,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            _vm.$set(
                                                              _vm.countIncomes[
                                                                store.id
                                                              ],
                                                              inv.id,
                                                              $$a.concat([$$v])
                                                            )
                                                        } else {
                                                          $$i > -1 &&
                                                            _vm.$set(
                                                              _vm.countIncomes[
                                                                store.id
                                                              ],
                                                              inv.id,
                                                              $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                )
                                                            )
                                                        }
                                                      } else {
                                                        _vm.$set(
                                                          _vm.countIncomes[
                                                            store.id
                                                          ],
                                                          inv.id,
                                                          $$c
                                                        )
                                                      }
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("strong", [
                                                  _vm._v(_vm._s(inv.id)),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-xs btn-info newWindowBtn",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showInvoice(
                                                          inv.id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "icon-fa icon-fa-eye",
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-xs btn-success",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.mixinGoToRouter(
                                                          "InvoicesEdit",
                                                          { id: inv.id }
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        Открыть\n                      "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-xs btn-success newWindowBtn",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.openInNewPage(
                                                          "InvoicesEdit",
                                                          { id: inv.id }
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "icon-fa icon-fa-external-link",
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                      (" +
                                                    _vm._s(
                                                      _vm.invoiceStatuses[
                                                        inv.status
                                                      ]
                                                    ) +
                                                    ")\n                    "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.storeDetails[store.id].invoiceInUse.out &&
                                Object.keys(
                                  _vm.storeDetails[store.id].invoiceInUse.out
                                ).length
                                  ? _c("div", [
                                      _vm._v(
                                        "\n                  Накладные отправления с текщего склада:\n                  "
                                      ),
                                      _c(
                                        "div",
                                        _vm._l(
                                          _vm.getInvoiceList(
                                            _vm.storeDetails[store.id]
                                              .invoiceInUse.out
                                          ),
                                          function (inv, ind) {
                                            return _c("div", { key: ind.id }, [
                                              _c("strong", [
                                                _vm._v(_vm._s(inv.id)),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-xs btn-success",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.mixinGoToRouter(
                                                        "InvoicesEdit",
                                                        { id: inv.id }
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        Открыть\n                      "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-xs btn-success newWindowBtn",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.openInNewPage(
                                                        "InvoicesEdit",
                                                        { id: inv.id }
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "icon-fa icon-fa-external-link",
                                                  }),
                                                ]
                                              ),
                                              _vm._v(
                                                "\n                      (" +
                                                  _vm._s(
                                                    _vm.invoiceStatuses[
                                                      inv.status
                                                    ]
                                                  ) +
                                                  ")\n                    "
                                              ),
                                            ])
                                          }
                                        ),
                                        0
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.storeDetails[store.id].collectingInvoices &&
                                _vm.storeDetails[store.id].collectingInvoices
                                  .length
                                  ? _c(
                                      "div",
                                      [
                                        _vm._v(
                                          "\n                  Накладные на сборке:\n                  "
                                        ),
                                        _vm._l(
                                          _vm.storeDetails[store.id]
                                            .collectingInvoices,
                                          function (inv) {
                                            return _c("div", [
                                              _c("strong", [
                                                _vm._v(_vm._s(inv.id)),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-xs btn-info newWindowBtn",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.showInvoice(
                                                        inv.id
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "icon-fa icon-fa-eye",
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-xs btn-success",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.mixinGoToRouter(
                                                        "InvoicesEdit",
                                                        { id: inv.id }
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Открыть\n                    "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-xs btn-success newWindowBtn",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.openInNewPage(
                                                        "InvoicesEdit",
                                                        { id: inv.id }
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "icon-fa icon-fa-external-link",
                                                  }),
                                                ]
                                              ),
                                            ])
                                          }
                                        ),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _c("DrugList", {
                              attrs: {
                                figures: _vm.storeDetails[store.id].drugFigures,
                                drugs: _vm.storeDetails[store.id].drugs,
                                ignoredDrugs: _vm.ignoredDrugs,
                              },
                            }),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ])
              : _vm._e()
          }),
          0
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Излишки")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }